import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoading$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  showLoader(loading: boolean) {
    this.isLoading$.next(loading);
  }
}
